export const DEV_TOOLS_VERSION_ALERT_QUERY = 'refreshAlertDevTools'
